// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.locationDeleteModal__t_doV {
  height: 560px;
  width: 372px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.modalBody__w3R9g {
  height: 100%;
  flex: 1;
  flex-direction: column;
  align-items: center;
  padding: 35px 51px 0;
}

.modalBodyTitle__ijpYe {
  text-align: center;
  margin-bottom: 35px;
  color: var(--header-title-main);
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  text-transform: uppercase;
}

.modalBodyFirstConfirmText__LoNIJ {
  text-align: center;
  white-space: pre-line;
  color: var(--tables-secondary-row-sub-title-text);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
}

.loader__FAru7 > img {
  width: 70px;
}

.link__jAwDG {
  color: var(--buttons-surface);
  cursor: pointer;
  text-decoration: none;
}

.modalBodySecondConfirmText__TxPo1 {
  color: var(--tables-secondary-row-sub-title-text);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  text-align: center;
  white-space: pre-line;
  margin-bottom: 8px;
}

.modalFooter__lAwf1 {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 30px;
  padding: 0 51px 35px;
}`, "",{"version":3,"sources":["webpack://./../src/components/modals/LocationDeleteModal/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,aAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAzEF;;AA4EA;EACE,YAAA;EACA,OAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;AAzEF;;AA4EA;EACE,kBAAA;EACA,mBAAA;EA1BA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AA9CF;;AAuEA;EACE,kBAAA;EACA,qBAAA;EACA,iDAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AApEF;;AAwEE;EACE,WAAA;AArEJ;;AAyEA;EACE,6BAAA;EACA,eAAA;EACA,qBAAA;AAtEF;;AAyEA;EACE,iDAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;AAtEF;;AAyEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,oBAAA;AAtEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.locationDeleteModal {\n  height: 560px;\n  width: 372px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.modalBody {\n  height: 100%;\n  flex: 1;\n  flex-direction: column;\n  align-items: center;\n  padding: 35px 51px 0;\n}\n\n.modalBodyTitle {\n  text-align: center;\n  margin-bottom: 35px;\n  @include modalTitle;\n}\n\n.modalBodyFirstConfirmText {\n  text-align: center;\n  white-space: pre-line;\n  color: var(--tables-secondary-row-sub-title-text);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px;\n}\n\n.loader {\n  & > img {\n    width: 70px;\n  }\n}\n\n.link {\n  color: var(--buttons-surface);\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.modalBodySecondConfirmText {\n  color: var(--tables-secondary-row-sub-title-text);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px;\n  text-align: center;\n  white-space: pre-line;\n  margin-bottom: 8px;\n}\n\n.modalFooter {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  margin-top: 30px;\n  padding: 0 51px 35px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"locationDeleteModal": `locationDeleteModal__t_doV`,
	"modalBody": `modalBody__w3R9g`,
	"modalBodyTitle": `modalBodyTitle__ijpYe`,
	"modalBodyFirstConfirmText": `modalBodyFirstConfirmText__LoNIJ`,
	"loader": `loader__FAru7`,
	"link": `link__jAwDG`,
	"modalBodySecondConfirmText": `modalBodySecondConfirmText__TxPo1`,
	"modalFooter": `modalFooter__lAwf1`
};
module.exports = ___CSS_LOADER_EXPORT___;
